import CustomerView from 'models/location/customer_view';
import { ExternalCustomerLookupStatusValue } from 'models/external_customer_lookup_status';

export default function requestCustomerExtension(context, customerId) {
  if (context.stores.externalCustomerLookupStatus.get().status !== ExternalCustomerLookupStatusValue.OK) {
    return;
  }

  context.gateways.customerExtension.update(customerId);
  let currentLocation = context.stores.currentLocation.get();
  if (currentLocation instanceof CustomerView && currentLocation.customerId === customerId) {
    currentLocation.setCustomerExtensionPending();
    context.stores.currentLocation.set(currentLocation);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/external_customer_lookup/request_customer_extension.js